import React from 'react'

import { SiteContext } from 'context/site-context'
import { sortBy } from 'lodash'

import { useHistory } from 'react-router-dom'

import Carousel from 'components/atoms/Carousel'
import Categories from 'components/sections/Categories'
import ExternalLinks from 'components/atoms/ExternalLinks'
import Modal from 'components/atoms/Modal'
import Reviews from 'components/atoms/Reviews'
import ReviewSubmissionForm from 'components/atoms/ReviewSubmissionForm'

import PRIMARY_IMAGES from './primary_images.js'

import {
  formatPhoneNumber,
  getQS,
} from 'helpers'

import './index.scss'

const getAddress = (address = {}) => {
  // Sigh...
  if(address.street && address.street === 'null') { delete address.street1 }
  if(address.city && address.city === 'null') { delete address.city }
  if(address.state && address.state === 'null') { delete address.state }

  return address.street || address.city || address.state ?
    `${address.street || ''} ${address.city || ''}${address.city && address.state ? ',' : ''} ${address.state || ''} ${address.postal_code || ''}` :
    ''
}

const ProfileDetails = props => {
  const [ site, setSite ] = React.useContext(SiteContext)

  const [ state, setState ] = React.useState({
    isEmpty: false,
    isLoading: true,
    reviews: [],
  })
  const [ reviewModalShow, setReviewModalShow ] = React.useState(false)

  let history = useHistory()

  const cleanImages = (images = []) => {
    if(images.length > 0 && window.location.protocol === 'https:'){
      // Iterate over the images array.  If any url is NOT https, remove it.
      console.debug('filtered images by protocol...', images.filter( image => image.image_url.indexOf('https') > -1 ))
      images = images.filter( image => image.image_url.indexOf('https') > -1 )
    }

    // HACK
    // Scan the list of "primary" images.  If there's a match in that list to one of the images in the array, set the "primary" value to "true".
    images.map( image => {
      try {
        let imagesrc = image.image_url.substr(0, image.image_url.lastIndexOf('_'))
          .substr(image.image_url.lastIndexOf('/'))
          .replace(/\//g, '')
          .replace(/_/g, '')
        if(PRIMARY_IMAGES.indexOf(imagesrc) > -1){
          image.primary = true
        }
      } catch(e) {
        // need a comment.
      }

      return image
    })
    // END HACK

    // Sort images so any with "primary" set to "true" come first.
    images = sortBy(images, ['primary']).reverse()

    return images
  }

  const fireTracking = url => {
    if(!url){
      return
    }

    const tracker = new Image()
    tracker.src = `${url}&action_target=listing_profile`
  }

  const getHomeUrl = () => {
    const qs = getQS().trim().length > 0 ? `?${getQS()}` : ''
    return `${window.location.origin}/${site.path ? `${site.path}/${qs}` : qs}`
  }

  const renderAttribution = ( data = {} ) => {
    if(data.attribution_logo) {
      return <div className="provider-container">
        <span>Provided by</span>
        {data.attribution_url ? <a href={data.attribution_url}><img src={data.attribution_logo} /></a> : <img src={data.attribution_logo} />}
      </div>
    }

    if(data.attribution_text) {
      return <div className="provider-container">
        <span>Provided by</span>
        {data.attribution_url ? <a href={data.attribution_url}>{data.attribution_text}</a> : <span>{data.attribution_text}</span>}
      </div>
    }
    return null
  }

  const renderBullets = ( bullets = [] ) => {
    if(!bullets) return

    return bullets.length > 0 ? <ul className="bullets-container">
      {bullets.map( bullet => <li key={bullet} dangerouslySetInnerHTML={{ __html: bullet }} /> )}
    </ul> : null
  }

  React.useEffect( () => {
    async function loadData() {
      try {
        const response = await fetch(`https://apis.elocal.com/citygrid/profile/places/v2/detail?id=${props.id}&publisher=${site.rialto.publisher}&format=json`)
        .catch( e => {
          setState( prevState => ({
            ...prevState,
            isLoading: false,
            isEmpty: true,
          }))
        })

        const json = await response.json()

        if(json.errors){
          setState( prevState => ({
            ...prevState,
            isLoading: false,
            isEmpty: true,
          }))
        } else {
          const result = json?.locations && json.locations.length ? json.locations[0] : {}

          fireTracking(result.impression_url)

          // result.images = cleanImages(result.images)

          setState( prevState => ({
            ...prevState,
            isLoading: false,
            ...result,
            isEmpty: !result.name,
          }))

          setSite({
            ...site,
            profile_listing: result,
          })
        }
      } catch(e){
        setState( prevState => ({
          ...prevState,
          isEmpty: true,
          isLoading: false,
        }))
      }
    }
    !site.isLoadingSiteData && loadData()

  }, [site.isLoadingSiteData])

  React.useEffect( () => {
    // Retrieve any review content.
    async function loadReviews() {
      try {
        const url = 'https://apis.elocal.com/citygrid/imported-listing/reviews'
        const response = await fetch(url, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify([props.id])
        })
  
        if(response.status >= 200 && response.status <=299){
          const json = await response.json()
          setState( prevState => ({
            ...prevState,
            reviews: json[props.id] || [],
          }))
        } else {
          console.debug(response.status, response.statusText)
        }
      } catch(e){
        console.debug('error', e)
      }
    }
    !site.isLoadingSiteData && loadReviews()
  }, [site.isLoadingSiteData])

  return <div className="profile-details-container">
    <div className="container">
      {!state.isLoading && !state.isEmpty && <React.Fragment>
        <div className="business-details-wrapper">
          {state.images?.length > 0 && <Carousel images={state.images} video={state.raw_video_url} />}
          <div className="business-details">
            <h1 className="business-name">{state.name}{state.business_operation_status === 'closed' && <span className="closed">Closed</span>}</h1>
            <div className="address">{getAddress(state.address)}</div>
            <ExternalLinks urls={state.urls} address={state.address} businessName={state.name} businessId={state.listingId} businessPhone={state.contact_info?.display_phone} />
            <div className="phone-trigger">{state.contact_info?.display_phone && <a href={`tel:${state.contact_info?.display_phone}`}>{formatPhoneNumber(state.contact_info?.display_phone)}</a>}</div>
            {state.business_hours && <div className="business-hours">Business Hours: <span dangerouslySetInnerHTML={{ __html: state.business_hours}} /></div>}
            {state.teaser && <div className="teaser" dangerouslySetInnerHTML={{ __html: state.teaser}} />}
            {renderBullets(state.customer_content?.bullets)}
          </div>
        </div>

        {(state.customer_content?.customer_message || renderAttribution(state)) && <div className="panel-container customer-content">
          <h2>About {state.name}</h2>
          <div className="panel-details" dangerouslySetInnerHTML={{ __html: state.customer_content?.customer_message}} />
          {renderAttribution(state)}
        </div>}

        {state.categories?.length > 0 && <div className="panel-container">
          <h3>Additional Details</h3>
          <div className="panel-details">
            {state.categories.map( category => category.name ).join(', ')}
          </div>
        </div>}

        <div className="panel-container">
          <h3>Reviews</h3>
          <span className="review-submission-modal-trigger button-trigger mini" onClick={ () => setReviewModalShow(true) }>Submit a review</span>
          <Modal show={reviewModalShow} onClose={ () => setReviewModalShow(false) }>
            <ReviewSubmissionForm listing={state} />
          </Modal>
          {state.reviews.length > 0 && <Reviews reviews={state.reviews} />}
        </div>
      </React.Fragment>}

      {!state.isLoading && state.isEmpty && <div className="empty-container">
        <div>
          <h3>We're sorry, but the business information is not available at this time.</h3>
          {props.slug && <span className="button-trigger mini" onClick={ () => window.location.href = getHomeUrl() }>Try a different search</span>}
          {!props.slug && <span className="button-trigger mini" onClick={ () => history.goBack() }>Return to results page</span>}
        </div>
      </div>}

      {state.isLoading && <div className="loading-container">
        <h3>Loading...</h3>
      </div>}
    </div>
    <Categories />
  </div>
}

export default ProfileDetails
